import { on, isServer, isVisible } from './dom';
import { isMac, isMobie} from './env';
import { isPointInsidePolygon } from './point-in-polygon';
import { isObject } from './types';

const nodeList = [];
const ctx = '@@clickoutsideContext';

let startClick;
let seed = 0;
const eventStart = isMobie ? 'touchstart' : 'mousedown';
const eventEnd = isMobie ? 'touchend' : 'mouseup';

!isServer && on(document, eventStart, e => (startClick = e));

!isServer && on(document, eventEnd, e => {
  if ((e.which !== 1 && !isMobie) || (isMac && e.ctrlKey)) {
    return;
  }
  nodeList.forEach(node => node[ctx].documentHandler(e, startClick));
});

const isPointsInsidePolygons = (points = [], polygons = []) => {
  return points.every(point => {
    return polygons.some(polygon => isPointInsidePolygon(point, [polygon]));
  });
};

const makePoints = (mouseupEvent, mousedownEvent, originEl) => {
  const { x, y } = originEl.getBoundingClientRect();
  const toPoint = (mouseEvent) => [mouseEvent.clientX - x, mouseEvent.clientY - y];
  return [toPoint(mousedownEvent), toPoint(mouseupEvent)];
};

export const HOT_AREA_TARGET = {
  self: 'self',
  popper: 'popper'
};

function createDocumentHandler(el, binding, vnode) {
  return function(mouseup = {}, mousedown = {}) {
    if (!vnode || !vnode.context) {
      return;
    }
    const popperElm = vnode.context.popperElm || vnode.context.relatedPopperElm;
    if ((mouseup.target &&
      mousedown.target &&
      el.contains(mouseup.target) &&
      el.contains(mousedown.target)) ||
      el === mouseup.target || (popperElm &&
        popperElm.contains(mouseup.target) &&
        popperElm.contains(mousedown.target))) {
      const hotSpot = binding.arg;
      if (!hotSpot || !isObject(hotSpot)) {
        return;
      }
      // support popperDom hotArea in cascader when height is auto
      // clicked point should locate in targetDom hotArea, otherwise it is outside
      const { polygons = [], target } = hotSpot;
      const bindToPopper = target === HOT_AREA_TARGET.popper;
      let hotAreaDom = bindToPopper ? popperElm : el;

      if (!polygons.length) {
        return;
      }
      if (polygons.length && hotAreaDom && isVisible(hotAreaDom)) {
        // for popper scene, only care clicked points which insides popperElm
        if (bindToPopper && (!hotAreaDom.contains(mouseup.target) || !hotAreaDom.contains(mousedown.target))) return;
        const points = makePoints(mouseup, mousedown, hotAreaDom);
        if (isPointsInsidePolygons(points, polygons)) return;
      }
    }
    if (binding.expression &&
      el[ctx].methodName &&
      vnode.context[el[ctx].methodName]) {
      vnode.context[el[ctx].methodName]();
    } else {
      el[ctx].bindingFn && el[ctx].bindingFn();
    }
  };
}

/**
 * v-clickoutside
 * @desc 点击元素外面才会触发的事件
 * @example
 * ```vue
 * <div v-element-clickoutside="handleClose">
 * ```
 */
export default {
  bind(el, binding, vnode) {
    nodeList.push(el);
    const id = seed++;
    el[ctx] = {
      id,
      documentHandler: createDocumentHandler(el, binding, vnode),
      methodName: binding.expression,
      bindingFn: binding.value
    };
  },

  update(el, binding, vnode) {
    el[ctx].documentHandler = createDocumentHandler(el, binding, vnode);
    el[ctx].methodName = binding.expression;
    el[ctx].bindingFn = binding.value;
  },

  unbind(el) {
    let len = nodeList.length;

    for (let i = 0; i < len; i++) {
      if (nodeList[i][ctx].id === el[ctx].id) {
        nodeList.splice(i, 1);
        break;
      }
    }
    delete el[ctx];
  }
};
